import * as React from "react";

const IconBucketTop: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="638" height="101" viewBox="0 0 638 101">
            <g fill="none" fillRule="evenodd">
                <polygon fill="#E1EAF1" points="0 0 0 101 638 53.093 638 0" />
                <polygon fill="#09273E" points="0 0 .405 79 638 48.405 638 0" />
            </g>
        </svg>
    );
};

export default React.memo(IconBucketTop);
